import React, { useState } from "react";

import { Switch, Route } from "react-router-dom";

import TeacherSalaries from "../../finance/_lists/TeacherSalaries";
import StaffSalaries from "../../finance/_lists/StaffSalaries";
import DebtPayments from "../../finance/_lists/DebtPayments";
import DirectExpenses from "../../finance/_lists/DirectExpenses";
import IndirectExpenses from "../../finance/_lists/IndirectExpenses";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import { useEffect } from "react";

const Expenses = (props) => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [tableTitles, setTableTitles] = useState({
    mainTitle: "مصارف",
  });

  const {halfYearId} = props.match.params;

  useEffect(() => {
    const { tid } = props.match.params;

    switch (tid) {
      case "1":
        setTableTitles({ mainTitle: "معاشات استادان" });
        break;
      case "2":
        setTableTitles({ mainTitle: "معاشات کارمندان" });
        break;
      case "3":
        setTableTitles({ mainTitle: "مصارف مستقیم" });
        break;
      case "4":
        setTableTitles({ mainTitle: "مصارق غیر مستقیم" });
        break;
      case "5":
        setTableTitles({ mainTitle: "پرداخت بدهی ها" });
        break;
    }
  }, []);

  return (
    <main className="main-print-wrapper">
      <PrintHeader
        printHeadTexts={printHeadTexts}
        title={tableTitles.mainTitle}
      />
      <PrintBodyTitle title={[]} />
      <div className="print-table-area">
        <Switch>
          <Route path="/print/expenses/5" render={() => <DebtPayments halfYearId={halfYearId} />} />
          <Route path="/print/expenses/4" render={() => <IndirectExpenses halfYearId={halfYearId} />} />
          <Route path="/print/expenses/3" render={() => <DirectExpenses halfYearId={halfYearId} />} />
          <Route path="/print/expenses/2" render={() => <StaffSalaries halfYearId={halfYearId} />} />
          <Route path="/print/expenses/1" render={() => <TeacherSalaries halfYearId={halfYearId} />} />
        </Switch>
      </div>
    </main>
  );
};

export default Expenses;
